// extracted by mini-css-extract-plugin
export default {"container":"ContainerNoteBanner_container__zlagO","content":"ContainerNoteBanner_content__ttpVi"};